export default __webpack_public_path__ + "static/media/025-ripped jeans.a6e5f08c.svg";